import { useEffect, useNavigate, useState, moment } from '../../common/common';
import axiosJWT, { setNavigate } from '../../secureAPI/axiosJWT';


// import getUserData  from '../../secureAPI/GetUserData';
// import useNavigation from '../../common/useNavigation.js';
import useGetUserData from '../../secureAPI/GetUserData';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';
import Navigations from '../../common/useNavigation.js';
import { showToast } from '../../Utils/toastUtils.js';

const MidDashboard = (type) => {
    const { navigateDashboard, navigateBuyerBusinessdetails } = Navigations();
    const { users, userPlan, Remainuser, subUser } = useGetUserData();

    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(true);
    const [distributorRequest, setDistributorRequest] = useState(0);

    
    const [orders, setOrders] = useState({
        Newordersrs: 0,
        Confirmorders: 0,
        Onholdorders: 0,
        Onprocessorders: 0,
        Completedorders: 0,
        Cancelledorders: 0,
        RemainingOrders: 0,
        DistributorRequest: 0,
        toatlDistributors: 0,
        totalPlansOrders: 0,
        totalUsersCount:0,
        usedUserCounts:0,
    })

    const [buyerOrders, seyBuyerOrders] = useState({
        Newordersrs: 0,
        Confirmorders: 0,
        Onholdorders: 0,
        Onprocessorders: 0,
        Completedorders: 0,
        Cancelledorders: 0,
        RemainingOrders: 0,
        supplierRequest: 0,
        totalSupplier: 0,
        totalOrders: 0,
    })

    const [planDetails, setplanDetails] = useState({
        startDate: '',
        endDate: '',
        PlanName: '',
        palnStatus: ''
    })
    const navigate = useNavigate();
    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    useEffect(() => {
        showToast('', '');
        fetchAllOrdersData();
        fetchUserPlanData();
        // getUserData(setUsers,setisLoading,setisDisabled,navigateMain);
        // getdistributorRequest();
    }, []);

    useEffect(() => {
        const logUserData = () => {
            if (users?.length > 0 && type !== '') {
                const userTypes = users[0]['UserType'];
                const usertypeArray = typeof userTypes === 'string' ?
                    userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

                const hasOne = usertypeArray.includes(1);
                const hasTwo = usertypeArray.includes(2);

                if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {
                    // Seller logic
                } else {
                    navigateDashboard('buyer');
                }


                if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (hasOne || (hasOne && hasTwo))) {


                    const requiredFields = ["Name", "Initials"];

                    const requiredFieldsAreNull = requiredFields.every(
                        (key) => users[0].CompanyDetails[key] === null || users[0].CompanyDetails[key] === ""
                    );

                    if (requiredFieldsAreNull) {
                        navigateBuyerBusinessdetails("buyer");
                    } else {
                        navigateDashboard('buyer');
                    }
                }
                if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {


                    const requiredFields = ["Name", "Initials"];

                    const requiredFieldsAreNull = requiredFields.every(
                        (key) => users[0].CompanyDetails[key] === null || users[0].CompanyDetails[key] === ""
                    );

                    if (requiredFieldsAreNull) {
                        navigateBuyerBusinessdetails("seller");
                    } else {
                        navigateDashboard('seller');
                    }

                }
            }
        };

        if (Array.isArray(users) && users.length > 0) {
            logUserData();
        }
    }, [users, type]);

    // useEffect(() => {
    //     //  console.log('called useeffectsss');
    //       if (Array.isArray(users) && users.length > 0) {
    //           console.log('useEffect called, users:', users);
    //           logUserData(); 
    //       }
    //   }, [users]); 

    //     const logUserData = () => {
    //       if (users?.length > 0) {


    //       }
    //     };


    // Fetch all order data in one function to reduce repetition
    const fetchAllOrdersData = async () => {

        try {
            StartLoading(setisLoading, setisDisabled);
            const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetAllOrdersCounts`, {}, { withCredentials: true });
            // console.log(response.data);
            setOrders({
                Newordersrs: response.data.responseData.newOrderCount,
                Confirmorders: response.data.responseData.confirmedOrderCount,
                Onholdorders: response.data.responseData.onholdOrderCount,
                Onprocessorders: response.data.responseData.onProcessOrderCount,
                Completedorders: response.data.responseData.onCompleteOrderCount,
                Cancelledorders: response.data.responseData.onCancelledCount,
                RemainingOrders: response.data.responseData.remainingOrdersCount,
                DistributorRequest: response.data.responseData.distributorRequestCount,
                toatlDistributors: response.data.responseData.sellerInTotalDistributor,
                totalPlansOrders: response.data.responseData.sellerPlanOrders,
                totalUsersCount:response.data.responseData.userTotalCounts,
                usedUserCounts:response.data.responseData.usedUserCounts,
            })

            seyBuyerOrders({
                Newordersrs: response.data.buyerResponseData.newOrderCount,
                Confirmorders: response.data.buyerResponseData.confirmedOrderCount,
                Onholdorders: response.data.buyerResponseData.onholdOrderCount,
                Onprocessorders: response.data.buyerResponseData.onProcessOrderCount,
                Completedorders: response.data.buyerResponseData.onCompleteOrderCount,
                Cancelledorders: response.data.buyerResponseData.onCancelledCount,

                supplierRequest: response.data.buyerResponseData.supplierRequest,
                totalSupplier: response.data.buyerResponseData.buyerInTotalSupplier,
                totalOrders: response.data.buyerResponseData.buyerTotalOrders,
            })

        } catch (err) {
            // console.error("Failed to load new orders, please try again later ", err);
        } finally {
            StopLoading(setisLoading, setisDisabled)
        }
        // await Promise.all([
        //     getNewOrders(),
        //     getConfirmOrders(),
        //     getOnHoldOrders(),
        //     getOnProcessOrders(),
        //     getCompletedOrders(),
        //     getCancelledOrders()
        // ]);

    };
    const fetchUserPlanData = async () => {

        try {
            StartLoading(setisLoading, setisDisabled);
            const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetUserPlansDetails`, {}, { withCredentials: true });
            if (response.data?.success && response.data.data?.length > 0) {
                const plan = response.data.data[0];

                setplanDetails({
                    startDate: moment(plan.start_date).format("DD-MMMM-YYYY"),
                    endDate: moment(plan.end_date).format("DD-MMMM-YYYY"),
                    PlanName: plan.plan_name,
                    palnStatus: plan.order_status,
                });
            }
        } catch (err) {
            // console.error("Failed to load new orders, please try again later ", err);
        } finally {
            StopLoading(setisLoading, setisDisabled)
        }


    };



    // const [distributors, setDistributors] = useState([]);

    //   console.log({ users: users });
    // const getdistributorRequest = async () => {
    //     StartLoading(setisLoading, setisDisabled);
    //     await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetdistributorRequest`,{app:0},{ withCredentials: true })
    //         .then((res) => {
    //             if (res.data.data.length > 0) {
    //                 console.log(res.data.data);
    //                 setDistributorRequest(res.data.data.length)
    //                 // setDistributors(res.data.data);
    //                 StartLoading(setisLoading, setisDisabled);
    //             }
    //             else {
    //                 StopLoading(setisLoading, setisDisabled)
    //             }
    //         })
    //         .catch((err) => {
    //             StopLoading(setisLoading, setisDisabled)
    //         });
    // }
    // const getNewOrders = async () => {
    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetNeworder`, {app:0, type: 2 });
    //         if (response?.data?.length > 0) {
    //             setOrders((prevOrders) => ({ ...prevOrders, Newordersrs: response.data.length }));
    //         }
    //     } catch (err) {
    //         // console.error("Failed to load new orders, please try again later ", err);
    //     } finally {
    //         StopLoading(setisLoading, setisDisabled)
    //     }
    // };
    // const getConfirmOrders = async () => {
    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetConfirmorders`, {app:0, type: 2 });
    //         if (response?.data?.length > 0) {
    //             setOrders((prevOrders) => ({ ...prevOrders, Confirmorders: response.data.length }));
    //         }
    //     } catch (err) {
    //         // console.error("Failed to load new orders, please try again later ", err);
    //     } finally {
    //         StopLoading(setisLoading, setisDisabled)
    //     }
    // };
    // const getOnHoldOrders = async () => {
    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetOnholdorders`, {app:0, type: 2 });
    //         if (response?.data?.length > 0) {
    //             setOrders((prevOrders) => ({ ...prevOrders, Confirmorders: response.data.length }));
    //         }
    //     } catch (err) {
    //         // console.error("Failed to load new orders, please try again later ", err);
    //     } finally {
    //         StopLoading(setisLoading, setisDisabled)
    //     }
    // };
    // const getOnProcessOrders = async () => {
    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetOnprocessororders`, {app:0, type: 2 });
    //         if (response?.data?.length > 0) {
    //             setOrders((prevOrders) => ({ ...prevOrders, Confirmorders: response.data.length }));
    //         }
    //     } catch (err) {
    //         // console.error("Failed to load new orders, please try again later ", err);
    //     } finally {
    //         StopLoading(setisLoading, setisDisabled)
    //     }
    // };
    // const getCompletedOrders = async () => {
    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetCompletedorders`, {app:0, type: 2 });
    //         if (response?.data?.length > 0) {
    //             setOrders((prevOrders) => ({ ...prevOrders, Confirmorders: response.data.length }));
    //         }
    //     } catch (err) {
    //         // console.error("Failed to load new orders, please try again later ", err);
    //     } finally {
    //         StopLoading(setisLoading, setisDisabled)
    //     }
    // };
    // const getCancelledOrders = async () => {
    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetCancelledorders`, {app:0, type: 2 });
    //         if (response?.data?.length > 0) {
    //             StopLoading(setisLoading, setisDisabled)
    //             setOrders((prevOrders) => ({ ...prevOrders, Confirmorders: response.data.length }));
    //         }
    //     } catch (err) {
    //         // console.error("Failed to load new orders, please try again later ", err);
    //     } finally {
    //         StopLoading(setisLoading, setisDisabled)
    //     }
    // };

    return {
        users, userPlan, Remainuser, subUser,
        orders, distributorRequest, isLoading, setisLoading, isDisabled, setisDisabled, planDetails, buyerOrders
    }
}

export default MidDashboard